import * as yup from 'yup';
import moment from 'moment';

// Utilities

import { isRif } from '../../../../utilities/validations.helper-functions';

// Constants

import { NO_SPECIAL_CHARACTERS_VALIDATION_REGEX } from '../../../../config/constants';

const addressSchema = yup.object().shape({
  sameAddress: yup.string().required('Este campo es requerido'),
  pais: yup.string().required('Este campo es requerido'),
  descDireccion: yup.string().when("pais", {
    is: (val) => val !== '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  entidad: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  ciudad: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  municipio: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  parroquia: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  urbanizacion: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  callecarretera: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  calle: yup.string().test(
    "direccion-group",
    "Debe completar al menos uno: avenida, calle o esquina",
    function (value) {
      const { avenida, calle, esquina, pais } = this.parent;

      if (pais !== '0') return true;

      return [avenida, calle, esquina].some(
        (v) => typeof v === "string" && v.trim() !== ""
      );
    }
  ),
  avenida: yup.string().test(
    "direccion-group",
    "Debe completar al menos uno: avenida, calle o esquina",
    function (value) {
      const { avenida, calle, esquina, pais } = this.parent;

      if (pais !== '0') return true;

      return [avenida, calle, esquina].some(
        (v) => typeof v === "string" && v.trim() !== ""
      );
    }
  ),
  esquina: yup.string().test(
    "direccion-group",
    "Debe completar al menos uno: avenida, calle o esquina",
    function (value) {
      const { avenida, calle, esquina, pais } = this.parent;

      if (pais !== '0') return true;

      return [avenida, calle, esquina].some(
        (v) => typeof v === "string" && v.trim() !== ""
      );
    }
  ),
  observaciones: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string(),
    otherwise: yup.string(),
  }),
  tipoInmueble: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  nombreInmueble: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  torre: yup.string().when(["pais", "tipoInmueble"], {
    is: (pais, tipoInmueble) => !['1', '2'].includes(tipoInmueble) && pais === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  piso: yup.string().when("pais", {
    is: (val) => val === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  apartamento: yup.string().when(["pais", "tipoInmueble"], {
    is: (pais, tipoInmueble) => ['3', '5'].includes(tipoInmueble) && pais === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  edificio: yup.string().when(["pais", "tipoInmueble"], {
    is: (pais, tipoInmueble) => !['1', '2', '3', '5'].includes(tipoInmueble) && pais === '0',
    then: yup.string().required('Este campo es requerido'),
    otherwise: yup.string(),
  }),
  oficina: yup.string().when(["pais", "tipoInmueble"], {
    is: (pais, tipoInmueble) => !['1', '2', '3', '5'].includes(tipoInmueble) && pais === '0',
    then: yup.string().required('Este campo es requerido').test("oficinaTest", "Favor no introducir caracteres especiales", function (value) {
      return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
    }),
    otherwise: yup.string(),
  }),
  local: yup.string().when(["pais", "tipoInmueble"], {
    is: (pais, tipoInmueble) => !['1', '2', '3', '5'].includes(tipoInmueble) && pais === '0',
    then: yup.string().required('Este campo es requerido').test("localTest", "Favor no introducir caracteres especiales", function (value) {
      return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
    }),
    otherwise: yup.string(),
  }),
  telefono1: yup.object().when('pais', {
    is: (val) => val === '0',
    then: yup.object().shape({
      tipo: yup.string().required('Este campo es requerido'),
      codigoArea: yup.string().required('Este campo es requerido'),
      numero: yup.string().required('Este campo es requerido').length(7, 'Digite el teléfono completo'),
    }),
    otherwise: yup.object().shape({
      tipo: yup.string().required('Este campo es requerido'),
      codigoArea: yup.string().required('Este campo es requerido').min(1, 'Digite el código de area completo'),
      numero: yup.string().required('Este campo es requerido').min(7, 'El teléfono debe tener al menos 7 dígitos'),
    }),
  }),
})

export const validationSchema = [
  yup.object().shape({
    jobReferences: yup.object().shape({
      hasJob: yup.string().required('Este campo es requerido').test("validacionTipoClienteEmpleo", "Debe introducir Empleo.", function (value) {
        if (this.parent.tipoCliente === '1' && value === 'no') {
          return false;
        } else {
          return true;
        }
      }),
      empleo: yup.object().when('hasJob', {
        is: (val) => val === 'si',
        then: yup.object().shape({
          address: addressSchema,
          fechaConsIng: yup.string().required('Este campo es requerido').test("fechaConstanciaTest", "Fecha de constancia no puede ser mayor de 90 dias.", function (value) {
            const currentDate = moment();
            const constancyDate = moment(value);
            const dateDifference = currentDate.diff(constancyDate, 'days');

            if (dateDifference > 90) {
              return false;
            } else {
              return true;
            }
          }),
          rifType: yup.string().required('Este campo es requerido'),
          rif: yup.string().required('Este campo es requerido').test("validacionRif", "Por favor ingrese un rif válido.", function (value) {
            if (this.parent.rifType === "P") {
              return true;
            }
            if (this.parent.rifType && value) {
              const nationality = this.parent.rifType === "E" ? 1 : 0;
              return isRif(this.parent.rifType + value, nationality);
            } else {
              return false;
            }
          }),
          moneda: yup.string().required('Este campo es requerido'),
          sueldoMensual: yup.string().required('Este campo es requerido'),
          tipoContrato: yup.string().required('Este campo es requerido'),
          nombreEmpresa: yup.string().required('Este campo es requerido').test("nombreEmpresaTest", "Favor no introducir caracteres especiales", function (value) {
            return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
          }),
          cargo: yup.string().required('Este campo es requerido'),
          rol: yup.string().required('Este campo es requerido'),
          fechaIngreso: yup.string().required('Este campo es requerido').test("fechaIngresoTest", "Fecha de constancia es anterior a la fecha de ingreso.", function (value) {
            const jobStartDate = moment(value);
            const constancyDate = moment(this.parent.fechaConsIng);
            const dateDifference = constancyDate.isBefore(jobStartDate);

            if (dateDifference) {
              return false;
            } else {
              return true;
            }
          }),
          email: yup.string().email('Ingrese un email válido.'),
          ramo: yup.string().required('Este campo es requerido').required('Este campo es requerido').test("ramoTest", "Favor no introducir caracteres especiales", function (value) {
            return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
          }),
          otraMoneda: yup.string().when('sueldoBonificacion', {
            is: (val) => (val != 0 && val != undefined && val != ''),
            then: yup.string().required('Este campo es requerido'),
            otherwise: yup.string(),
          }),
          sueldoBonificacion: yup.string(),
        }),
      }),
      hasIncome: yup.string().required('Este campo es requerido').test("validacionTipoClienteIngreso", "Debe introducir Otro Ingreso y/o Negocio Propio.", function (value) {
        if (this.parent.tipoCliente === '2' && this.parent.hasBusiness === 'no' && value === 'no') {
          return false;
        } else {
          return true;
        }
      }),
      ingreso: yup.object().when('hasIncome', {
        is: (val) => val === 'si',
        then: yup.object().shape({
          address: addressSchema,
          fechaConsIng: yup.string().required('Este campo es requerido').test(
            'fecha-minima',
            '',
            function (value) {
              if (!value) return true;

              const jobReferences = this.from
                ?.map(item => item.value)
                ?.find(item => item?.tipoCliente);

              const tipoCliente = jobReferences?.tipoCliente;

              let minDays;

              if (tipoCliente === '2') {
                minDays = 90;
              } else if (tipoCliente === '1') {
                minDays = 30;
              } else {
                return true;
              }

              const minDate = moment().subtract(minDays, 'days').startOf('day');

              if (!moment(value).isSameOrAfter(minDate)) {
                return this.createError({
                  message: `La fecha de la constancia debe ser menor de ${minDays} días.`
                });
              }

              return true;
            }
          ),
          montoEstimado: yup.string().required('Este campo es requerido'),
          moneda: yup.string().required('Este campo es requerido'),
          email: yup.string().email('Ingrese un email válido.'),
          otrosIngresos: yup.string().required('Este campo es requerido'),
        }),
      }),
      hasBusiness: yup.string().required('Este campo es requerido').test("validacionTipoClienteBusiness", "Debe introducir Otro Ingreso y/o Negocio Propio.", function (value) {
        if (this.parent.tipoCliente === '2' && this.parent.hasIncome === 'no' && value === 'no') {
          return false;
        } else {
          return true;
        }
      }),
      negocioPropio: yup.object().when('hasBusiness', {
        is: (val) => val === 'si',
        then: yup.object().shape({
          address: addressSchema,
          fechaConstitutiva: yup.string().required('Este campo es requerido'),
          rifType: yup.string().required('Este campo es requerido'),
          rif: yup.string().required('Este campo es requerido').test("validacionRif", "Por favor ingrese un rif válido.", function (value) {
            if (this.parent.rifType === "P") {
              return true;
            }
            if (this.parent.rifType && value) {
              const nationality = this.parent.rifType === "E" ? 1 : 0;
              return isRif(this.parent.rifType + value, nationality);
            } else {
              return false;
            }
          }),
          nombreNegocio: yup.string().required('Este campo es requerido').test("nombreNegocioTest", "Favor no introducir caracteres especiales", function (value) {
            return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
          }),
          numeroNegocio: yup.string().required('Este campo es requerido'),
          datosRegistro: yup.string().required('Este campo es requerido').test("datosRegistroTest", "Favor no introducir caracteres especiales", function (value) {
            return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
          }),
          libro: yup.string().required('Este campo es requerido'),
          folio: yup.string().required('Este campo es requerido'),
          moneda: yup.string().required('Este campo es requerido'),
          ingresos: yup.string().required('Este campo es requerido'),
          ramo: yup.string().required('Este campo es requerido').test("ramoTest", "Favor no introducir caracteres especiales", function (value) {
            return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
          }),
          email: yup.string().email('Ingrese un email válido.'),
          businessSuppliers: yup.array().min(1).of(
            yup.object({
              searchedOnList: yup.boolean().required('').test("searchedOnListTest", "", function (value) {
                return value === true;
              }),
              isOnList: yup.boolean().required('').test("isOnListTest", "", function (value) {
                return value === false;
              }),
              nombreCompleto: yup.string().required('Este campo es requerido').test("nombreCompleto", "Favor no introducir caracteres especiales", function (value) {
                return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
              }),
              pais: yup.string().required('Este campo es requerido'),
              entidad: yup.string().when('pais', {
                is: (val) => val === '0',
                then: yup.string().required('Este campo es requerido')
              }),
              telefono: yup.string().when('pais', {
                is: (val) => val === '0',
                then: yup.string().required('Este campo es requerido').length(10, 'Digite el teléfono completo'),
                otherwise: yup.string().required('Este campo es requerido').min(10, 'Digite el teléfono completo'),
              }),
            }),
          ),
          businessClients: yup.array().min(1).of(
            yup.object({
              searchedOnList: yup.boolean().required('').test("searchedOnListTest", "", function (value) {
                return value === true;
              }),
              isOnList: yup.boolean().required('').test("isOnListTest", "", function (value) {
                return value === false;
              }),
              nombreCompleto: yup.string().required('Este campo es requerido').test("nombreCompleto", "Favor no introducir caracteres especiales", function (value) {
                return NO_SPECIAL_CHARACTERS_VALIDATION_REGEX?.test(value);
              }),
              pais: yup.string().required('Este campo es requerido'),
              entidad: yup.string().when('pais', {
                is: (val) => val === '0',
                then: yup.string().required('Este campo es requerido')
              }),
              telefono: yup.string().when('pais', {
                is: (val) => val === '0',
                then: yup.string().required('Este campo es requerido').length(10, 'Digite el teléfono completo'),
                otherwise: yup.string().required('Este campo es requerido').min(10, 'Digite el teléfono completo'),
              }),
            }),
          ),
        }),
      }),
    }),
  }),
];